<script setup>
import { onMounted, ref } from "vue";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { prefersReducedMotion } from "@utils/prefersReducedMotion";

const props = defineProps(["column_one", "column_two"]);

const section = ref(null);
const columnOneEl = ref(null);
const columnTwoEl = ref(null);

onMounted(() => {
	if (prefersReducedMotion()) return;

	gsap.registerPlugin(ScrollTrigger);

	const scrollTrigger = ScrollTrigger.create({
		trigger: section.value,
		start: "top 80%",
		end: "bottom 20%",
		toggleActions: "play none none none",
	});

	const elements = [];
	if (columnOneEl.value) elements.push(columnOneEl.value);
	if (columnTwoEl.value) elements.push(columnTwoEl.value);

	elements.forEach((el, index) => {
		gsap.from(el, {
			y: 24,
			opacity: 0,
			duration: 0.8,
			delay: index * 0.1,
			ease: "power2.out",
			scrollTrigger: scrollTrigger,
		});
	});
});
</script>

<template>
	<section class="py-40 lg:py-80" ref="section">
		<div class="container">
			<div class="grid grid-cols-8 gap-x-16 gap-y-40">
				<div
					class="col-span-8 flex flex-col gap-32 lg:col-span-3"
					ref="columnOneEl"
				>
					<p v-if="column_one.tag" class="h9 font-primary">
						{{ column_one.tag }}
					</p>
					<p
						v-if="column_one.title"
						class="lg:h3 h5 font-primary-condensed"
					>
						{{ column_one.title }}
					</p>
					<p v-if="column_one.paragraph" class="text-sm opacity-75">
						{{ column_one.paragraph }}
					</p>
				</div>

				<div
					class="col-span-8 flex flex-col gap-32 lg:col-span-4 lg:col-start-5"
					ref="columnTwoEl"
				>
					<p v-if="column_two.tag" class="h9 font-primary">
						{{ column_two.tag }}
					</p>
					<p
						v-if="column_two.title"
						class="lg:h3 h5 font-primary-condensed"
					>
						{{ column_two.title }}
					</p>
					<p v-if="column_two.paragraph" class="text-sm opacity-75">
						{{ column_two.paragraph }}
					</p>
				</div>
			</div>
		</div>
	</section>
</template>
